import React from 'react'
import Button from './Button'
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import { useTranslation } from 'next-i18next'

function PaginationNxtPrev({ page = 1, lastPage = false, prevHreh, nxtHref }) {
    const { t } = useTranslation(['common', 'news'])
    return (
        <div className="inline-flex gap-2">
            <Button
                type="linkButton"
                hoverColor={
                    page <= 1 ? 'transparent' : 'darkGray'
                }
                color={page <= 1 ? 'lighterGray' : 'white'}
                disabled={page <= 1}
                className="flex-nowrap inline-flex"
                href={prevHreh}
            >
                <BsArrowRightShort
                    style={{ display: 'inline' }}
                />
                {t('صفحه ی قبلی', { ns: 'common' })}
            </Button>

            <Button
                type="linkButton"
                hoverColor={
                    lastPage ? 'transparent' : 'darkGray'
                }
                color={lastPage ? 'lighterGray' : 'white'}
                disabled={lastPage}
                className="flex-nowrap inline-flex"
                href={nxtHref}
            >
                {t('صفحه ی بعد', { ns: 'common' })}
                <BsArrowLeftShort
                    style={{ display: 'inline' }}
                />
            </Button>
        </div>
    )
}

export default PaginationNxtPrev